export default __webpack_public_path__ + "static/media/why-client-love.c1895bcd.png";